<template>
  <div class="faq-wrapper d-flex justify-content-center">
    <div class="faq-container container">
      <div class="row">
        <div class="col-12 mb-4 mb-lg-0 col-lg-3">
          <FaqNavbar />
        </div>
        <div class="col-xs-12 col-lg-9">
          <section class="kl-faq-list">
            <div v-if="data.chapters">
              <accordion>
                <accordion-item
                  v-for="chapter in data.chapters"
                  :key="chapter.id"
                  :target="`${chapter.id}`"
                >
                  <template slot="accordion-trigger">
                    <button class="btn btn-link px-0">
                      <p class="mb-0 subtitle4--regular">
                        {{ chapter.title }}
                      </p>
                    </button>
                    <span
                      ><ArrowIcon
                        color="secondary"
                        rotate="point-down"
                        class="kl-faq-arrow"
                    /></span>
                  </template>
                  <template slot="accordion-content">
                    <div
                      v-for="topic in chapter.topics"
                      :id="topic.id"
                      :key="topic.id"
                      class="kl-faq-item"
                    >
                      <p class="body3--semiBold mb-0">
                        <router-link
                          :to="`${$route.params.module}/${topic.id}`"
                        >
                          {{ topic.question }}
                        </router-link>
                      </p>
                    </div>
                  </template>
                </accordion-item>
              </accordion>
            </div>
            <div v-if="data.topics">
              <div
                v-for="topic in data.topics"
                :id="topic.id"
                :key="topic.id"
                class="kl-faq-item"
              >
                <p class="body3--semiBold">
                  <router-link :to="`${$route.params.module}/${topic.id}`">
                    {{ topic.question }}
                  </router-link>
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FaqNavbar from "./FaqNavbar.vue";
import helpContent from "../content/help.json";
import ArrowIcon from "./icons/ArrowIcon";
import Accordion from "./AccordionComponent.vue";
import AccordionItem from "../components/AccordionItem.vue";

export default {
  name: "PomocView",
  components: {
    FaqNavbar,
    ArrowIcon,
    Accordion,
    AccordionItem,
  },
  beforeRouteUpdate(to, from, next) {
    this.data = helpContent.find((item) => item.name === to.params.module);
    next();
  },
  data() {
    return {
      data: helpContent.find((item) => item.name === this.$route.params.module),
    };
  },
  created() {
    this.$emit("showFaqHeader", true);
  },
  mounted() {
    document.title = "Pomoc";
  },
};
</script>
